export const STAGES = [
  "booked", "assigned", "driver_accepted", "en_route_pickup", "arrived_pickup", "onboard",
  "en_route_destination", "arrived_destination", "completed", "payment_finalized",
];

export const STAGE_LABELS = {
  booked: "Booked",
  assigned: "Assigned",
  driver_accepted: "Driver accepted",
  en_route_pickup: "En route to pickup",
  arrived_pickup: "Arrived at pickup",
  onboard: "Passenger onboard",
  en_route_destination: "En route to destination",
  arrived_destination: "Arrived at destination",
  completed: "Completed",
  payment_finalized: "Payment finalized",
  declined: "Declined by driver",
  no_show: "Passenger no-show",
};

// What the chauffeur sees on the single primary action button for each stage.
export const DRIVER_ACTIONS = {
  driver_accepted: { stage: "en_route_pickup", label: "START TO PICKUP" },
  en_route_pickup: { stage: "arrived_pickup", label: "I'M HERE" },
  arrived_pickup: { stage: "onboard", label: "START TRIP" },
  onboard: { stage: "en_route_destination", label: "HEAD TO DESTINATION" },
  en_route_destination: { stage: "arrived_destination", label: "ARRIVED AT DESTINATION" },
  arrived_destination: { stage: "completed", label: "COMPLETE TRIP" },
};

export const STAGE_COLORS = {
  booked: "#94a3b8",
  assigned: "#94a3b8",
  driver_accepted: "#34d399",
  en_route_pickup: "#60a5fa",
  arrived_pickup: "#fb923c",
  onboard: "#c084fc",
  en_route_destination: "#c084fc",
  arrived_destination: "#facc15",
  completed: "#64748b",
  payment_finalized: "#475569",
  declined: "#f87171",
  no_show: "#f59e0b",
};

export const stageLabel = (stage) => STAGE_LABELS[stage] || (stage || "").replace(/_/g, " ");
export const stageIndex = (stage) => STAGES.indexOf(stage);
export const isLive = (stage) =>
  ["driver_accepted", "en_route_pickup", "arrived_pickup", "onboard", "en_route_destination", "arrived_destination"]
    .includes(stage);

export const clock = (minutes) => {
  const m = Math.max(0, Math.round(minutes || 0));
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
};
